import {LABELS} from '@github-ui/issues-shared/labels'
import {SortDescIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, VisuallyHidden} from '@primer/react'

import {getViewsSortOption, VIEWS_SORT_OPTIONS, type ViewsSortValue} from './views-sort-options'

type ViewsSortMenuProps = {
  sort: ViewsSortValue
  onSortChange: (value: ViewsSortValue) => void
}

export function ViewsSortMenu({sort, onSortChange}: ViewsSortMenuProps) {
  const selected = getViewsSortOption(sort)

  return (
    <ActionMenu>
      <ActionMenu.Button variant="invisible" leadingVisual={SortDescIcon}>
        <VisuallyHidden>{LABELS.sortBy} </VisuallyHidden>
        {selected.label}
      </ActionMenu.Button>
      <ActionMenu.Overlay align="end">
        <ActionList selectionVariant="single">
          <ActionList.Group>
            <ActionList.GroupHeading>{LABELS.sortBy}</ActionList.GroupHeading>
            {VIEWS_SORT_OPTIONS.map(option => (
              <ActionList.Item
                key={option.value}
                selected={option.value === sort}
                onSelect={() => onSortChange(option.value)}
              >
                {option.label}
              </ActionList.Item>
            ))}
          </ActionList.Group>
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
